/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIaRouteImport } from './routes/admin-ia'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FitRouteImport } from './routes/fit'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LojaRouteImport } from './routes/loja'
import { Route as NotificacoesRouteImport } from './routes/notificacoes'
import { Route as ParametrizacaoRouteImport } from './routes/parametrizacao'
import { Route as PerfisRouteImport } from './routes/perfis'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as SolicitacoesRouteImport } from './routes/solicitacoes'
import { Route as CardIdRouteImport } from './routes/card.$id'
import { Route as ConviteTokenRouteImport } from './routes/convite.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIaRoute = AdminIaRouteImport.update({
  id: '/admin-ia',
  path: '/admin-ia',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FitRoute = FitRouteImport.update({
  id: '/fit',
  path: '/fit',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LojaRoute = LojaRouteImport.update({
  id: '/loja',
  path: '/loja',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificacoesRoute = NotificacoesRouteImport.update({
  id: '/notificacoes',
  path: '/notificacoes',
  getParentRoute: () => rootRouteImport,
} as any)
const ParametrizacaoRoute = ParametrizacaoRouteImport.update({
  id: '/parametrizacao',
  path: '/parametrizacao',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfisRoute = PerfisRouteImport.update({
  id: '/perfis',
  path: '/perfis',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const SolicitacoesRoute = SolicitacoesRouteImport.update({
  id: '/solicitacoes',
  path: '/solicitacoes',
  getParentRoute: () => rootRouteImport,
} as any)
const CardIdRoute = CardIdRouteImport.update({
  id: '/card/$id',
  path: '/card/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ConviteTokenRoute = ConviteTokenRouteImport.update({
  id: '/convite/$token',
  path: '/convite/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-ia': typeof AdminIaRoute
  '/dashboard': typeof DashboardRoute
  '/fit': typeof FitRoute
  '/login': typeof LoginRoute
  '/loja': typeof LojaRoute
  '/notificacoes': typeof NotificacoesRoute
  '/parametrizacao': typeof ParametrizacaoRoute
  '/perfis': typeof PerfisRoute
  '/pipeline': typeof PipelineRoute
  '/solicitacoes': typeof SolicitacoesRoute
  '/card/$id': typeof CardIdRoute
  '/convite/$token': typeof ConviteTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-ia': typeof AdminIaRoute
  '/dashboard': typeof DashboardRoute
  '/fit': typeof FitRoute
  '/login': typeof LoginRoute
  '/loja': typeof LojaRoute
  '/notificacoes': typeof NotificacoesRoute
  '/parametrizacao': typeof ParametrizacaoRoute
  '/perfis': typeof PerfisRoute
  '/pipeline': typeof PipelineRoute
  '/solicitacoes': typeof SolicitacoesRoute
  '/card/$id': typeof CardIdRoute
  '/convite/$token': typeof ConviteTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin-ia': typeof AdminIaRoute
  '/dashboard': typeof DashboardRoute
  '/fit': typeof FitRoute
  '/login': typeof LoginRoute
  '/loja': typeof LojaRoute
  '/notificacoes': typeof NotificacoesRoute
  '/parametrizacao': typeof ParametrizacaoRoute
  '/perfis': typeof PerfisRoute
  '/pipeline': typeof PipelineRoute
  '/solicitacoes': typeof SolicitacoesRoute
  '/card/$id': typeof CardIdRoute
  '/convite/$token': typeof ConviteTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-ia'
    | '/dashboard'
    | '/fit'
    | '/login'
    | '/loja'
    | '/notificacoes'
    | '/parametrizacao'
    | '/perfis'
    | '/pipeline'
    | '/solicitacoes'
    | '/card/$id'
    | '/convite/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-ia'
    | '/dashboard'
    | '/fit'
    | '/login'
    | '/loja'
    | '/notificacoes'
    | '/parametrizacao'
    | '/perfis'
    | '/pipeline'
    | '/solicitacoes'
    | '/card/$id'
    | '/convite/$token'
  id:
    | '__root__'
    | '/'
    | '/admin-ia'
    | '/dashboard'
    | '/fit'
    | '/login'
    | '/loja'
    | '/notificacoes'
    | '/parametrizacao'
    | '/perfis'
    | '/pipeline'
    | '/solicitacoes'
    | '/card/$id'
    | '/convite/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminIaRoute: typeof AdminIaRoute
  DashboardRoute: typeof DashboardRoute
  FitRoute: typeof FitRoute
  LoginRoute: typeof LoginRoute
  LojaRoute: typeof LojaRoute
  NotificacoesRoute: typeof NotificacoesRoute
  ParametrizacaoRoute: typeof ParametrizacaoRoute
  PerfisRoute: typeof PerfisRoute
  PipelineRoute: typeof PipelineRoute
  SolicitacoesRoute: typeof SolicitacoesRoute
  CardIdRoute: typeof CardIdRoute
  ConviteTokenRoute: typeof ConviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-ia': {
      id: '/admin-ia'
      path: '/admin-ia'
      fullPath: '/admin-ia'
      preLoaderRoute: typeof AdminIaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fit': {
      id: '/fit'
      path: '/fit'
      fullPath: '/fit'
      preLoaderRoute: typeof FitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loja': {
      id: '/loja'
      path: '/loja'
      fullPath: '/loja'
      preLoaderRoute: typeof LojaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notificacoes': {
      id: '/notificacoes'
      path: '/notificacoes'
      fullPath: '/notificacoes'
      preLoaderRoute: typeof NotificacoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parametrizacao': {
      id: '/parametrizacao'
      path: '/parametrizacao'
      fullPath: '/parametrizacao'
      preLoaderRoute: typeof ParametrizacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfis': {
      id: '/perfis'
      path: '/perfis'
      fullPath: '/perfis'
      preLoaderRoute: typeof PerfisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solicitacoes': {
      id: '/solicitacoes'
      path: '/solicitacoes'
      fullPath: '/solicitacoes'
      preLoaderRoute: typeof SolicitacoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/$id': {
      id: '/card/$id'
      path: '/card/$id'
      fullPath: '/card/$id'
      preLoaderRoute: typeof CardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/convite/$token': {
      id: '/convite/$token'
      path: '/convite/$token'
      fullPath: '/convite/$token'
      preLoaderRoute: typeof ConviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminIaRoute: AdminIaRoute,
  DashboardRoute: DashboardRoute,
  FitRoute: FitRoute,
  LoginRoute: LoginRoute,
  LojaRoute: LojaRoute,
  NotificacoesRoute: NotificacoesRoute,
  ParametrizacaoRoute: ParametrizacaoRoute,
  PerfisRoute: PerfisRoute,
  PipelineRoute: PipelineRoute,
  SolicitacoesRoute: SolicitacoesRoute,
  CardIdRoute: CardIdRoute,
  ConviteTokenRoute: ConviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
